import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { UnknownAction } from 'redux-saga';

import { Tag, useTag } from '../store/tag';
import { Option } from '../types';
import { tagList, tagListClear } from '../store/tag/list';

export const useTagsAll = () => {
  const dispatch = useDispatch();
  const { list } = useTag();
  const [tags, setTags] = useState<Tag[]>([]);

  const options: Option[] = useMemo(
    () => tags.map(({ id, name }): Option => ({ label: name, value: id })),
    [tags],
  );

  const getTags = (page = 1, pageSize = 100) => {
    dispatch(tagList({ page, pageSize }) as UnknownAction);
  };

  useEffect(() => {
    getTags();

    return () => {
      dispatch(tagListClear() as UnknownAction);
    };
  }, []);

  useEffect(() => {
    if (list.response?.data) {
      setTags((prevState) => (
        list.response?.meta.page === 1 ? list.response.data : [...prevState, ...(list.response?.data || [])]
      ));

      if (list.response.meta.hasNextPage) {
        getTags(list.response.meta.page + 1, list.response.meta.pageSize);
      }
    }
  }, [list.response]);

  return { options, tags };
};

export default {
  useTagsAll,
};
